// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingPanelHeading_root__2X8N1","headingSpacing":"EditListingPanelHeading_headingSpacing__1dP-d"};